import type { QueryKey as QueryKeyTanstack } from '@tanstack/react-query';
import { queryClient } from 'config/queryClient';

export const resetQueryWhenNoObservers = (queryKey: QueryKeyTanstack, pollInterval = 1000) => {
  const checkAndReset = () => {
    const query = queryClient.getQueryCache().find(queryKey);

    if (!query) {
      return;
    }

    if (query.getObserversCount() === 0) {
      queryClient.resetQueries(queryKey);
      return;
    }

    setTimeout(checkAndReset, pollInterval);
  };

  setTimeout(checkAndReset, pollInterval);
};
